import axios from "axios";
import Base64 from './base64';
import Authorize from './authorize.js'
import { Message } from 'element-ui'

window.isDoingLogin = false;
export default {
	install(Vue, options) {
		Vue.prototype.$command = {
			execute: this.execute
		}
	},
	async execute(option = {
		api,
		parameter,
		exportCfg,
		notNeedLogin
	}) {
		var header = {
			"content-type": "application/json",
			"identity": localStorage.getItem('identity') || ''
		};
		if (option.exportCfg) {
			var base64 = new Base64()
			var exportStr = base64.encode(JSON.stringify(option.exportCfg));
			header.exportCfg = exportStr
		}
		let response = await axios
			.post(option.api, option.parameter, {
				headers: header
			});

		return new Promise(async (resolve, reject) => {
			if (response.data.code == 0) {
				//success
				if (option.exportCfg) {
					window.open(response.data.data);
				}

				resolve(response.data);
				return;
			}
			if (!option.notNeedLogin && response.data.code == 5) {
				localStorage.removeItem("identity");
				setTimeout(() => {
					if (window.isDoingLogin) {
						return;
					}
					window.isDoingLogin = true;
					//保存当前地址，登陆成功后将跳转到此处
					var gotoUrl = sessionStorage.getItem("goto-url");
					if (!gotoUrl) {
						sessionStorage.setItem("goto-url", location.href);
					}
					// 不是微信环境
					if (
						!(window.__wxjs_environment === "miniprogram" ||
							window.navigator.userAgent.toLowerCase().indexOf("micromessenger") >
							-1 ||
							window.navigator.wxuserAgent)
					) {
						//未登录
						if (confirm('请先登录')) {
							location.replace('/login');
						}
					} else {
						new Authorize().loginWechat();
					}
					setTimeout(() => {window.isDoingLogin = false;}, 200)
				}, 200)
			}
			if (response.data.code == 6) {  //无权限
				let parameters = { path: option.api }
				let result = await axios
					.post('/racl-merch-api/racl/GetApiInfo', JSON.stringify(parameters), {
						headers: header
					});
				Message({
					type: 'error',
					duration: 0,
					showClose: true,
					message: `当前账号无权访问【${result.data.data.name}】(${result.data.data.key})，请联系管理员`
				})
			}
			return reject(response.data);
		})
	}
}